import React from 'react';
import { ChevronsUpDown } from 'lucide-react';
import { BuySellAssetControllerStages, BuySellTabContentProps } from '@shared/types/frontend/assetPage';
import { Button } from '@/components/ui/button';
import ImageWithBadge from '../../../sendFunds/ImageWithBadge';
import getNetworkLogo from '@/lib/misc/getNetworkLogo';
import { useTouchHandlerName } from '@/hooks/utilities/use-mobile';
interface SelectFromToAssetProps {
  form: BuySellTabContentProps['form'];
  setStage: (_: BuySellAssetControllerStages) => void;
}
const MobileSelectFromToAsset = ({
  form,
  setStage
}: SelectFromToAssetProps) => {
  const touchHandlerName = useTouchHandlerName();
  return <Button type='button' variant='ghost' className='place-self-center flex justify-between p-4 h-[25px] w-[170px] items-center border border-genius-blue rounded-full' {...{
    [touchHandlerName]: () => {
      setStage(BuySellAssetControllerStages.tokenList);
    }
  }} data-sentry-element="Button" data-sentry-component="MobileSelectFromToAsset" data-sentry-source-file="MobileSelectFromToAsset.tsx">
      {form.watch('tradeSide') === 'buy' && <>
          {form.watch('fromToken') ? <>
              <ImageWithBadge mainImageSrc={form.watch('fromToken').logo_url} badgeImageSrc={getNetworkLogo(form.watch('fromToken').network)} badgeSize={16} size={24} />
              <p className='opacity-50'>Using:</p>
              <p className='text-[16px]'>{form.watch('fromToken').contract_ticker_symbol}</p>
              <ChevronsUpDown className='w-[16px]' />
            </> : <>
              <p>Select From</p>
              <ChevronsUpDown className='w-[16px]' />
            </>}
        </>}
      {form.watch('tradeSide') === 'sell' && <>
          {form.watch('toToken') ? <>
              <ImageWithBadge mainImageSrc={form.watch('toToken').logo_url} badgeImageSrc={getNetworkLogo(form.watch('toToken').network)} size={16} />
              <div className='flex gap-2'>
                <p className='opacity-50'>To:</p>
                <p className='text-[16px]'>{form.watch('toToken').contract_ticker_symbol}</p>
              </div>
              <ChevronsUpDown className='w-[16px]' />
            </> : <>
              <p>Select To</p>
              <ChevronsUpDown className='w-[16px]' />
            </>}
        </>}
    </Button>;
};
export default MobileSelectFromToAsset;